import React from 'react';
import { motion } from 'framer-motion';
export function DownloadCTA() {
  return <section id="download" className="py-24 bg-gradient-to-br from-brand-600 to-brand-800 relative overflow-hidden" data-id="element-144">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-145">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full mix-blend-overlay filter blur-3xl" data-id="element-146"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent-400 rounded-full mix-blend-overlay filter blur-3xl" data-id="element-147"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-149">
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-6 tracking-tight" data-id="element-150">
            Start Eating Smarter Today
          </h2>
          <p className="text-xl text-brand-100 mb-10 max-w-2xl mx-auto" data-id="element-151">
            Download IntelliEats for free and take control of what goes into
            your body. No hidden fees, just honest ingredients.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-152">
            <a href="https://apps.apple.com/us/app/intellieats/id6744873855" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-153">
              <button className="w-full sm:w-auto flex items-center justify-center px-8 py-4 bg-slate-900 text-white border border-slate-800 rounded-xl hover:bg-slate-800 transition-all hover:scale-105 duration-200 shadow-xl" data-id="element-154">
                <svg className="w-8 h-8 mr-3" viewBox="0 0 24 24" fill="currentColor" data-id="element-155">
                  <path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-156" />
                </svg>
                <div className="text-left" data-id="element-157">
                  <div className="text-xs uppercase font-bold opacity-60" data-id="element-158">
                    Download on the
                  </div>
                  <div className="text-lg font-black leading-none" data-id="element-159">
                    App Store
                  </div>
                </div>
              </button>
            </a>

            <a href="https://play.google.com/store/apps/details?id=com.Lakh.intelli_eats&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-160">
              <button className="w-full sm:w-auto flex items-center justify-center px-8 py-4 bg-slate-900 text-white border border-slate-800 rounded-xl hover:bg-slate-800 transition-all hover:scale-105 duration-200 shadow-xl" data-id="element-161">
                <svg className="w-8 h-8 mr-3" viewBox="0 0 24 24" fill="currentColor" data-id="element-162">
                  <path d="M3,20.5V3.5C3,2.91,3.34,2.39,3.84,2.15L13.69,12L3.84,21.85C3.34,21.6,3,21.09,3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08,20.75,11.5,20.75,12C20.75,12.5,20.5,12.92,20.16,13.19L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-163" />
                </svg>
                <div className="text-left" data-id="element-164">
                  <div className="text-xs uppercase font-bold opacity-60" data-id="element-165">
                    Get it on
                  </div>
                  <div className="text-lg font-black leading-none" data-id="element-166">
                    Google Play
                  </div>
                </div>
              </button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}